module.exports = __webpack_public_path__ + "img/why-choose-us.f9717752.webp";